/*
 * NOTICE OF LICENSE
 *
 * This source file is subject to the Academic Free License (AFL 3.0)
 *
 *  @author    Afternet <info@afternet.gr>
 *  @copyright 2022 Afternet
 *  @license   http://opensource.org/licenses/afl-3.0.php  Academic Free License (AFL 3.0)
 */
import React, {useEffect, useState, useRef} from 'react';
import PageBox from "../../layouts/pageBox";
import ListingTop from "../../components/ListingTop";
import ListingBottom from "../../components/ListingBottom";
import FiltersCars from "../../components/FiltersCars";
import CarBox from "../../components/CarBox";
import {useParams} from "react-router-dom";
import Loader from "../../elements/loader";
import FilterCheckbox from "../../elements/FilterCheckbox";
import useAxiosJTW from "../../Hooks/useAxiosJTW";
import {useTranslation} from "react-i18next";
import SEO from "../../components/SEO";

const CarsListing = () => {

    let params = useParams();
    const { t, i18n } = useTranslation();
    const scrollTop = useRef(null);

    const isInitialSort = useRef(true);

    const axiosJWT = useAxiosJTW();

    const [dataToSend, setDataToSend] = useState({
        page : 1,
        has_ads: '1',
        filter: '1',
        sort: 'date-desc',
        criteria: [],
        make_id: '',
        model: '',
        year: '',
        fuel: '',
        city: '',
        limit: 50
    });


    const [ads, setAds] = useState([]);
    const [criteria, setCriteria] = useState([]);

    const [sortValue, setSortValue] = useState('date-desc');
    const [totalPages, setTotalPages] = useState(1);
    const [totalItems, setTotalItems] = useState(0);

    const [isLoading, setIsLoading] = useState(true);
    const [filterLoading, setFilterLoading] = useState(true);

    const dataText = {
        title: t('meta_title.carListing'),
        subtitle: ''
    };

    const controller = new AbortController();
    const signal= controller.signal;

    const getads = ( dataToSend, signal) => {
        axiosJWT.post('api/getads', dataToSend, {signal}).then( (response) => {

            if(response.status === 200){

                setAds(response.data.ads || []);

                if( response.data.criteria ){
                    setCriteria(response.data.criteria);
                }

                setTotalPages( parseInt(response.data.total_pages) || 1 );
                setTotalItems(  parseInt(response.data.total_ads) );

                setIsLoading(false);
                setFilterLoading(false);
            }
        } ).catch((error) => {
            console.log(error);
        });

    }


    useEffect(() => {
        setIsLoading(true);

        getads( dataToSend, signal);

        return () => {controller.abort();}
    }, [params, dataToSend]);

    useEffect(() => {
        if (isInitialSort.current) {
            isInitialSort.current = false;
        } else {
            setDataToSend(prevState => ({
                ...prevState,
                page: 1,
                sort: sortValue
            }));
        }
        return () => {controller.abort();}
    }, [sortValue]);

    function onSubmitFilters(value){
        setDataToSend(prevState => ({
            ...prevState,
            page: 1,
            make_id: value.make_id,
            model: value.model_name,
            year: value.years,
            fuel: value.fuel,
            city: value.city
        }));
    }

    function onResetFilters(){
        setDataToSend(prevState => ({
            ...prevState,
            page: 1,
            make_id: '',
            model: '',
            year: '',
            fuel: '',
            city: ''
        }));
    }

    return (
        <>
            <SEO
                title={t('meta_title.carListing')}
                description={t('meta_description.carListing')}
            />
            <PageBox data={dataText}>

                <div className='page-body'>
                    <div ref={scrollTop} className='page-row'>
                        <div className='page-sidebar'>

                            {filterLoading ? (
                                <div style={{ paddingTop: '30px', textAlign : 'center' }}><Loader/></div>
                            ) : (
                                <>
                                    <FiltersCars
                                        onReset={onResetFilters}
                                        onSubmit={onSubmitFilters}
                                    />
                                    <div className='pt-5'>
                                        {
                                            criteria.map( (item, index) => (
                                                <FilterCheckbox selected={dataToSend.criteria} onSelect={setDataToSend} filter={item} key={index}/>
                                            ) )
                                        }
                                    </div>
                                </>
                            )}

                        </div>
                        <div className='page-content'>

                            <ListingTop value={sortValue} onSort={setSortValue} count={totalItems}/>

                            <div className='carBoxs'>
                                {isLoading ? (
                                    <div style={{ paddingTop: '30px', textAlign : 'center', margin: '0 auto' }}><Loader/></div>
                                ) : (
                                    ads.map((item, index) => {
                                        return(
                                            <CarBox key={index} ad={item}/>
                                        );
                                    })
                                )}
                            </div>

                            <ListingBottom currentPage={dataToSend.page} totalPages={totalPages} onChangePage={setDataToSend} scrollTop={scrollTop} green={true}/>

                        </div>
                    </div>

                </div>
            </PageBox>
        </>

    );
};

export default CarsListing;
